import(/* webpackMode: "eager" */ "/Users/chadlinmaalgraaff/Desktop/Skywalk/Pattern/pattern-dashboard/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/Users/chadlinmaalgraaff/Desktop/Skywalk/Pattern/pattern-dashboard/src/views/shared/ClientErrorTelemetry/ClientErrorTelemetry.tsx");
